import { render, staticRenderFns } from "./DashboardUserTasks.vue?vue&type=template&id=5bc980da&scoped=true&"
import script from "./DashboardUserTasks.vue?vue&type=script&lang=js&"
export * from "./DashboardUserTasks.vue?vue&type=script&lang=js&"
import style0 from "./DashboardUserTasks.vue?vue&type=style&index=0&id=5bc980da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc980da",
  null
  
)

export default component.exports